module.exports = __webpack_public_path__ + "img/paragon.0367bc18.png";